export default __webpack_public_path__ + "static/media/FoodChainOcean_08.d032990a.png";